"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueWithLabel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const ValueWithLabel = ({ label, children }) => ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(polaris_1.Box, { variant: "awsui-key-label", children: label }), (0, jsx_runtime_1.jsx)("div", { children: children })] }));
exports.ValueWithLabel = ValueWithLabel;
